import { render } from "./CardThirtyOne.vue?vue&type=template&id=37659351"
import script from "./CardThirtyOne.vue?vue&type=script&lang=js"
export * from "./CardThirtyOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__